// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jgile-dropdown-tree>button>.svg-inline--fa,.jgile-dropdown-tree>button>i{transition:all .3s}.jgile-dropdown-tree.active>button>.svg-inline--fa,.jgile-dropdown-tree.active>button>i{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
